import styled from 'styled-components';

import { Button as ButtonLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: white;
  margin-top: 10px;

  .fc .fc-toolbar-title {
    display: inline;
    font-size: 18px;
    color: #192c47;
    vertical-align: middle;
  }

  .fc .fc-button-primary:not(:disabled):active:focus,
  .fc .fc-button-primary:not(:disabled).fc-button-active:focus {
    box-shadow: none;
  }

  // targeting the right content of the calendar header
  .fc .fc-integrationLink-button{
    background-color: transparent;
    border: none;
    // default html link color
    color: #007bff;
    :hover, :focus, :active, :focus-visible{
      background-color: transparent !important;
      border: none !important;
      color: #192c47 !important;
    }
  }

  .fc .fc-integrationConnected-button{
    background-color: transparent;
    border: none;
    // default html link color
    color: #287C0C;
    ::before {
      content: " \u2022";
      padding-right: 0.5rem;
      font-size: 1rem;
    }
    :hover, :focus, :active, :focus-visible{
      background-color: transparent !important;
      border: none !important;
      color: #287C0C !important;
      box-shadow: none;
      cursor: default;
    }
  }

  .fc .fc-col-header-cell-cushion {
    color: #192c47;
    cursor: auto;
  }

  .fc-timegrid-event .fc-event-main {
    overflow: hidden;
  }

  .fc-timegrid-slot  {
    border-top-color: #B0B3B7;
  }

  .fc .fc-timegrid-slot-minor {
    border-top-color: #ddd;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
`;

export const SubmitButton = styled(ButtonLayoutComponent)`
  &.ui.button {
    width: 180px;
    margin-top: 20px;
  }
`;

export const Message = styled(TextLayoutComponent)`
  padding-top: 20px;
`;

export const DeleteEvent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  float: right;
  margin-right: 2px;
`;
